// Types
import { HeaderOnboardingVariantsType } from '../../../../designSystem/reloaded/commons/components/header-onboarding';
import { SIZES } from '../../../../designSystem/reloaded/commons/foundations';
import { DeviceBreakpointsType } from '../../../../types';
import { IconPositionType } from '@kubit-ui-web/react-components';
export const getButtonIconConfiguration = ({ device, variant, }) => {
    const result = {
        iconPosition: IconPositionType.LEFT,
        iconConfiguration: {
            icon: '',
            width: SIZES.size_250,
            height: SIZES.size_250,
        },
    };
    if (variant === HeaderOnboardingVariantsType.DEFAULT) {
        if ([DeviceBreakpointsType.MOBILE].includes(device)) {
            result.iconConfiguration.icon = 'icon_chevron_left';
        }
        else if ([DeviceBreakpointsType.TABLET].includes(device)) {
            result.iconConfiguration.icon = 'icon_chevron_left';
            result.iconConfiguration.width = SIZES.size_350;
            result.iconConfiguration.height = SIZES.size_350;
        }
        else {
            result.iconConfiguration.icon = 'icon_arrow_left-thick';
        }
        return result;
    }
    else if (variant === HeaderOnboardingVariantsType.MENU) {
        if (![DeviceBreakpointsType.MOBILE].includes(device)) {
            result.iconConfiguration.icon = 'icon_arrow_left-thick';
        }
    }
    return result;
};
export const getButtonChildrenConfiguration = ({ button, device, variant, }) => {
    if (variant === HeaderOnboardingVariantsType.DEFAULT) {
        return [DeviceBreakpointsType.TABLET, DeviceBreakpointsType.MOBILE].includes(device)
            ? ''
            : (button?.children ?? '');
    }
    return button?.children ?? '';
};
//# sourceMappingURL=header-onboarding.configuration.util.js.map